import { debounce, tryParseJSON } from '../../util';
import _ from 'lodash'

export class UndoManager<T>  {
    undoStack: Array<T> = [];
    redoStack: Array<T> = [];
    currentState: T = null;
    callbacks: Array<() => void> = [];
    _addState(obj: T, callback?: () => void) {
        if (_.isEqual(obj, this.currentState)) {
            return;
        }
        if (!!this.currentState) {
            this.undoStack.push(this.currentState);
            this.redoStack = [];
            this._updatedSaveChanges(obj)
        }

        this.currentState = obj;
        this.triggerCallbacks();
        if (!!callback) {
            callback();
        }
    }

    _updatedSaveChanges(obj: any) {
        let savedChanges = localStorage.getItem('uxp-widget-designer-changes')
        let allChanges = savedChanges ? tryParseJSON(savedChanges, {}) : {}
        if (!allChanges?.[location.pathname]) allChanges[location.pathname] = {}
        allChanges[location.pathname] = { ...obj }
        localStorage.setItem('uxp-widget-designer-changes', JSON.stringify(allChanges))

    }

    public addState = debounce(this._addState.bind(this), 500, { isImmediate: false });

    reset() {
        this.undoStack = [];
        this.redoStack = [];
        this.currentState = null;
    }
    onUndoRedo(callback: () => void) {
        this.callbacks.push(callback);
    }
    triggerCallbacks() {
        for (let f of this.callbacks)
            f();
    }

    undo(): T {
        if (this.undoStack.length == 0) {
            return null;
        }
        let j = this.undoStack.pop();
        this.redoStack.push(this.currentState);
        this.currentState = j;

        this._updatedSaveChanges(j)
        return j;
    }
    redo(): T {
        if (this.redoStack.length == 0) {
            return null;
        }
        let j = this.redoStack.pop();
        this.undoStack.push(this.currentState);
        this.currentState = j;
        this._updatedSaveChanges(j)

        return j;
    }
    canUndo(): boolean {
        return this.undoStack.length > 0;
    }
    canRedo(): boolean {
        return this.redoStack.length > 0;
    }
}
